<template>
	<Form ref="formValidate" :model="formValidate" :label-width="110" :label-colon="true">
		<Row>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="创建日期" prop="dateRange">
				<DatePicker type="daterange" v-model="formValidate.dateRange" :options="dateRangeOptions"
					format="yyyy/MM/dd" placement="bottom-start" placeholder="请选择" clearable />
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="公司名" :label-width="80">
				<Input v-model="formValidate.company" clearable />
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="状态" :label-width="100">
				<Select v-model="formValidate.status" style="width:200px" clearable>
					<Option :value="0" :key="0">待录取</Option>
					<Option :value="1" :key="1">已录取</Option>
					<Option :value="3" :key="3">已拒绝</Option>
					<Option :value="4" :key="4">已失效</Option>
					<Option :value="5" :key="5">报名失败</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="用户ID" :label-width="100">
				<Input v-model="formValidate.userId" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="手机号" :label-width="100">
				<Input v-model="formValidate.mobile" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="报名ID" :label-width="100">
				<Input v-model="formValidate.applyId" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="市场渠道" :label-width="100">
				<Input v-model="formValidate.storeChannel" clearable />
			</FormItem>
			</Col>
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="子渠道" :label-width="100">
				<Input v-model="formValidate.childChannelCode" clearable />
			</FormItem>
			</Col>
			
			<Col :md="6" :sm="12" :xs="24">
			<FormItem label="app" :label-width="60">
				<Select v-model="formValidate.appChannel" style="width:200px" clearable>
					<Option v-for="item in appChannels" :value="item.code" :key="item.code">{{ item.name }}
					</Option>
				</Select>
			</FormItem>
			</Col>
			<Col :md="12" :sm="12" :xs="24">
			<FormItem>
				<Button type="primary" @click="formSubmit" icon="md-search" style="margin: 0 8px 16px 0px;">查询</Button>
				<Button type="default" @click="formReset" style="margin: 0 8px 16px 16px;">重置</Button>
				<Button type="success" @click="exportExcel" icon="ios-cloud-download-outline"
					style="margin: 0 8px 16px 16px;">导出数据</Button>
			</FormItem>
			</Col>
		</Row>
	</Form>

</template>
<script>
	import api from '../../api'
	import {
		mapGetters
	} from 'vuex'
	import {
		STATISTICS_START_TIME,
		LINK_TYPES
	} from '../../config/constants'

	export default {
		name: 'QueryCondition',
		props: {

		},
		data() {
			return {
				apps: [],
				events: [],
				appId: '',
				advertType: 'table',
				appChannels:[{
					name:'兼职直聘',
					code:1,
				},{
					name:'应届生直聘',
					code:2,
				},{
					name:'线上日结兼职宅家赚',
					code:3,
				},{
					name:'蜗牛兼职',
					code:4,
				},{
					name:'支付宝小金豆',
					code:5,
				},{
					name:'大熊兼职商家版',
					code:6,
				},{
					name:'大熊兼职',
					code:7,
				},{
					name:'米罐兼职',
					code:8,
				}],
				formValidate: {
					dateRange: [],
					appChannel:undefined,
					company:undefined,
					userId:undefined,
					mobile:undefined,
					applyId:undefined,
					status:undefined,
					storeChannel:undefined,
					childChannelCode:undefined,
				},
				dateRangeOptions: {
					disabledDate(date) {
						const startDate = new Date(STATISTICS_START_TIME).getTime()
						const now = Date.now()
						return (
							date && !(date.valueOf() >= startDate && date.valueOf() <= now)
						)
					}
				}
			}
		},
		computed: {
			...mapGetters('statistics', ['accountGroup', 'pageStatus'])
		},
		mounted() {
			//获取全部app
			api.statistics
				.getAppPage({
					page: 1,
					limit: 100
				})
				.then(res => {
					this.apps = res.data.records
					if (this.apps.length > 0) {
						this.appId = this.apps[0].appKey
					}
				})
		},
		methods: {
			formSubmit() {
				this.$emit('query', this.getFormData())
			},
			exportExcel() {
				this.$emit('exportExcel', this.getFormData())
			},
			formReset() {
				this.$refs['formValidate'].resetFields()
				this.formValidate = {
					dateRange: [],
				}
				//this.formSubmit()
			},
			getFormData() {
				let beginTime= this.formValidate.dateRange[0] || null
				let endTime=this.formValidate.dateRange[1] || null
				const formData = {
					beginTime: beginTime?this.util.formatDateTime(beginTime):null,
					endTime: endTime?this.util.dateFormat(endTime,'yyyy-MM-dd')+' 23:59:59':null,
					appChannel:this.formValidate.appChannel,
					company:this.formValidate.company,
					userId:this.formValidate.userId,
					mobile:this.formValidate.mobile,
					applyId:this.formValidate.applyId,
					status:this.formValidate.status,
					storeChannel:this.formValidate.storeChannel,
					childChannelCode:this.formValidate.childChannelCode
				}
				return formData
			},

		}
	}
</script>